export default __webpack_public_path__ + "static/media/lol_banner.7c3fc8a8.png";